<template>
  <div
    :class="['group bg-gray-700 border-2 rounded-lg shadow-lg w-64 relative overflow-visible', selected ? 'border-blue-400' : data.__validationError ? 'border-red-500' : 'border-gray-600']"
  >
    <!-- Header del nodo -->
    <div class="bg-gray-800 p-3 rounded-t-lg flex items-center gap-2 justify-between">
      <div class="flex items-center gap-2">
        <span class="material-icons text-blue-400">rocket_launch</span>
        <strong class="text-white">{{ $t('flowEditor.nodes.startNode.title') }}</strong>
      </div>
      <ValidationMarker :error="data.__validationError" />
    </div>
    
    <!-- Corpo del nodo -->
    <div class="p-3">
      <p class="text-gray-400 text-xs mb-1">{{ $t('flowEditor.nodes.startNode.triggerLabel') }}</p>
      <p class="text-white text-sm truncate">
        {{ data.intentPhrases && data.intentPhrases.split('\n')[0] ? data.intentPhrases.split('\n')[0] : $t('flowEditor.nodes.startNode.emptyPlaceholder') }}
      </p>
    </div>

    <!-- Punti di connessione (Handles) -->
    <Handle type="source" :position="Position.Right" />
    <!-- Add node button -->
    <AddNodeButton v-if="!hasOutgoingEdge" @add="emit('add-node', nodeId)" />
  </div>
</template>

<script setup>
import { Handle, Position } from '@vue-flow/core';
import AddNodeButton from './AddNodeButton.vue';
import ValidationMarker from './ValidationMarker.vue';

const emit = defineEmits(['add-node']);

defineProps({
  data: { type: Object, required: true },
  selected: { type: Boolean, default: false },
  nodeId: { type: String, required: true },
  hasOutgoingEdge: { type: Boolean, default: false },
});
</script>
